import React, { useEffect } from 'react';
//Context
import { useFallas } from './FallasContext';
//Material-UI
import { Modal, TextField, Button, IconButton } from '@material-ui/core';
//Icons
import { CirclePlus, X } from 'tabler-icons-react';

export default function NuevaCatego() {
    const {
        text,
        setText,
        createCatego,
        handleOpenC,
        handleCloseC,
        openC,
        updateGridC,
        setUpdateGridC,
        getCatego,
    } = useFallas();

    useEffect(() => {
        if (updateGridC === true) {
            getCatego();
            setUpdateGridC(false);
        }
    }, [getCatego, setUpdateGridC, updateGridC]);

    const canSubmit = text.trim().length > 0;

    return (
        <>
            <Button
                className="fallas-btn-add"
                variant="text"
                color="default"
                onClick={handleOpenC}
            >
                <span className="fallas-btn-content">
                    <CirclePlus size={16} strokeWidth={2} />
                    Agregar
                </span>
            </Button>

            <Modal open={openC} onClose={handleCloseC}>
                <div className="fallas-modal">
                    <div className="fallas-modal-header">
                        <h2 className="fallas-modal-title">Nueva categoría</h2>
                        <IconButton size="small" onClick={handleCloseC}>
                            <X size={18} strokeWidth={2} />
                        </IconButton>
                    </div>

                    <div className="fallas-modal-body">
                        <TextField
                            label="Nombre"
                            value={text}
                            onChange={(e) => setText(e.target.value)}
                            fullWidth
                        />
                    </div>

                    <div className="fallas-modal-footer">
                        <Button
                            className="fallas-modal-cancel"
                            variant="outlined"
                            onClick={handleCloseC}
                        >
                            Cancelar
                        </Button>
                        <Button
                            className="fallas-modal-submit"
                            variant="contained"
                            color="primary"
                            onClick={createCatego}
                            disabled={!canSubmit}
                        >
                            Crear categoría
                        </Button>
                    </div>
                </div>
            </Modal>
        </>
    );
}
